import React, { Component } from 'react';
import { Switch, Route } from 'react-router-dom';

import List from './List';
import Detail from './Detail';

// Checker "Approvals" console. Mounted (non-exact) at /approvals by the router,
// so it owns its own nested routing for the list and per-request detail view.
export default class Approvals extends Component {
  render() {
    return (
      <Switch>
        <Route exact path="/approvals" component={List} />
        <Route path="/approvals/:reference" component={Detail} />
      </Switch>
    );
  }
}
